import React from 'react';
import './AppVersion.scss';

export var AppVersion = function AppVersion(_ref) {
  var version = _ref.version;
  return React.createElement(
    'span',
    { className: 'app-version' },
    'Version ',
    process.env.REACT_APP_BUILD || process.env.REACT_APP_VERSION || version
  );
};